import { FormulaCoverSortOptions } from '../models/formula.model';

import { FormulaType } from './formulaType';

export const PREVIEW_SVG_URLS = {
    android:
        'https://storage.googleapis.com/assets.aampe.com/app_images/preview_assets/android3.svg',
    ios: 'https://storage.googleapis.com/assets.aampe.com/app_images/preview_assets/iphone3.svg',
    whatsapp_android:
        'https://storage.googleapis.com/assets.aampe.com/app_images/preview_assets/whatsapp_android.svg',
    whatsapp_ios:
        'https://storage.googleapis.com/assets.aampe.com/app_images/preview_assets/whatsapp_ios.svg',
};

interface FilterOption {
    label: string;
    value: FormulaCoverSortOptions;
}

export const getCoverMessagePreviewFilterOptions = (
    formulaType: FormulaType,
): Partial<Record<FormulaCoverSortOptions, FilterOption>> => {
    let options: Partial<Record<FormulaCoverSortOptions, FilterOption>> = {};

    switch (formulaType) {
        case FormulaType.sms:
            options = {
                [FormulaCoverSortOptions.Message]: {
                    label: 'Message alphabetically',
                    value: FormulaCoverSortOptions.Message,
                },
            };
            break;

        case FormulaType.email:
            break;

        case FormulaType.mobilePush:
        default:
            options = {
                [FormulaCoverSortOptions.Header]: {
                    label: 'Header alphabetically',
                    value: FormulaCoverSortOptions.Header,
                },
                [FormulaCoverSortOptions.Body]: {
                    label: 'Body alphabetically',
                    value: FormulaCoverSortOptions.Body,
                },
            };
            break;
    }

    return {
        ...options,
        [FormulaCoverSortOptions.Random]: {
            label: 'Random order',
            value: FormulaCoverSortOptions.Random,
        },
    };
};
